import * as React from 'react';
import { useContext } from 'react';
import { Locales } from './types';

export const LocalesContext = React.createContext<Locales>({} as Locales);

const locales: () => Locales = () => useContext<Locales>(LocalesContext);

export default locales;
